import { AutogenModelUserMenuFavorite, AutogenRowUserMenuFavorite } from "./autogen/AutogenModelUserMenuFavorite";

export class ModelUserMenuFavorite extends AutogenModelUserMenuFavorite<RowUserMenuFavorite> {
	constructor() {
		super(RowUserMenuFavorite);
	}
}

export class RowUserMenuFavorite extends AutogenRowUserMenuFavorite {
}